import vxLiveChat from '../components/b2c/access-customer-service/vx-live-chat/vx-live-chat.vue';
import vxContactusUpload from '../components/b2c/access-customer-service/vx-contactus-upload/vx-contactus-upload.vue';
import vxContactUs from '../components/b2c/access-customer-service/vx-contact-us/vx-contact-us.vue';

const accessCustomerServiceModule = {
  components: {
    vxLiveChat,
    vxContactusUpload,
    vxContactUs,
  },
};

export default accessCustomerServiceModule;



// WEBPACK FOOTER //
// ./src/modules/access-customer-service-b2c.js